/* stylelint-disable value-no-vendor-prefix */
import styled from '@emotion/styled';
import PropTypes from 'prop-types';
import Avatar from '@base/Avatar/Avatar';
import P2 from '@base/P2/P2';
import Tags from '@base/Tags/Tags';
import Link from '@base/Link/Link';
import H6 from '@base/H6/H6';
import Grow from '@base/Grow/Grow';
import StarRating from '@base/StarRating/StarRating';
import { textTruncate } from '@utils/textHelper';
import { getLink, getLinkPath } from '@models/Course';
import { Spacings } from '../../../styleConstants';

const StyledFreeCourseCardDetails = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  justify-content: space-between;
  text-align: left;
  max-width: 240px;
  padding: ${Spacings.SPACING_4B}
    ${({ horizontal }) =>
      horizontal ? Spacings.SPACING_6B : Spacings.SPACING_4B};
`;

const TopicGroupTag = styled(Tags)`
  margin-left: ${Spacings.SPACING_2B};
`;

const CourseTitle = styled(H6)`
  margin-top: ${Spacings.SPACING_1B};
  margin-bottom: ${Spacings.SPACING_2B};
  color: var(--color-text-primary);
`;

const Educator = styled.div`
  display: flex;
  margin-top: ${Spacings.SPACING_4B};
`;

const EducatorAvatar = styled(Avatar)`
  border-radius: ${Spacings.SPACING_1B};
`;

const EducatorName = styled(P2)`
  margin-left: ${Spacings.SPACING_2B};
  color: var(--color-text-primary);
`;

const Rating = styled(StarRating)`
  margin-left: ${Spacings.SPACING_1B};
  margin-right: ${Spacings.SPACING_2B};
`;

const FreeCourseCardDetails = ({ course, orientation, handleAnalytics }) => {
  const {
    language,
    conceptTopology,
    name,
    averageRating,
    totalRatings,
    authors
  } = course;
  return (
    <StyledFreeCourseCardDetails orientation={orientation}>
      <div>
        {language && <Tags type="hollow">{language}</Tags>}
        {conceptTopology && (
          <TopicGroupTag type="disabled">
            {textTruncate(conceptTopology || '', 28)}
          </TopicGroupTag>
        )}
        <Link
          href={getLinkPath(course)}
          as={getLink(course)}
          onClick={handleAnalytics}
        >
          <CourseTitle lineClamp={2} as="h4">
            {name}
          </CourseTitle>
        </Link>
        {averageRating ? (
          <Rating rating={averageRating} ratingsCount={totalRatings} />
        ) : null}
      </div>
      <Grow />
      {authors?.[0]?.name && (
        <Link href="/[authorID]" as={`/@${authors?.[0]?.username}`}>
          <Educator>
            <EducatorAvatar
              src={authors?.[0]?.thumbnail}
              size={Spacings.SPACING_4B}
            />
            <EducatorName>{authors?.[0]?.name}</EducatorName>
          </Educator>
        </Link>
      )}
    </StyledFreeCourseCardDetails>
  );
};

export default FreeCourseCardDetails;

FreeCourseCardDetails.propTypes = {
  course: PropTypes.objectOf(PropTypes.any).isRequired,
  orientation: PropTypes.oneOf(['horizontal', 'vertical']),
  handleAnalytics: PropTypes.func.isRequired
};

FreeCourseCardDetails.defaultProps = {
  orientation: 'vertical'
};
